import { useQuery } from "react-query";
import axios from "infra/http";
import { PaginateResult } from "core/resources/types/shared";
import { AreaComumResponse } from "../typings";

function useAreasComum(
  tenantId: string | null,
  params: { page: number; search?: string; limit?: number; ativo?: boolean }
) {

  return useQuery(
    `/v1/tenants/${tenantId}/area-comum?page=${params.page}&search=${params.search}`,
    async () => {
      const { data } = await axios.get<PaginateResult<AreaComumResponse>>(
        `/v1/tenants/${tenantId}/area-comum`,
        {
          params,
        }
      );

      return data;
    }
  );
}

export default useAreasComum;
